module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/wappen-wallis-7617a2a79143fccbb8c24bb8fd796a47.jpg";